import { render, staticRenderFns } from "./DCOIcon.vue?vue&type=template&id=6d6feb3e&scoped=true"
import script from "./DCOIcon.vue?vue&type=script&lang=js"
export * from "./DCOIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6feb3e",
  null
  
)

export default component.exports